import React from 'react'
import { useSelector } from 'react-redux'
import SupplierContactItem from './SupplierContactItem'

const SupplierContactList = () => {

    const supplier = useSelector(state => state.supplier.supplier)

  return (
    <div>
        {
            supplier.contacts && supplier.contacts.length > 0 ?
                supplier.contacts.map((supplierContact, index) => 
                    <SupplierContactItem
                        key={supplierContact.id}
                        index={index}
                        supplierContact={supplierContact} 
                        // checked={checked}
                        // setChecked={setChecked}
                    />
                )
            : 
                <p>Контактів не знайдено</p>
        }
    </div>
  )
}

export default SupplierContactList